import { getStoredItem, setStoredItem } from 'app/modules/editor/scripts/storage';

import { ThemeActionTypes, ThemeActions } from './actions';

const STORAGE_KEY_THEME_TYPE = 'storage_key_theme_type';
export type ThemeType = 'light' | 'dark';

export interface State {
  readonly themeType: ThemeType;
  readonly isInitialPageLoad: boolean;
}

export function buildInitialState() {
  return {
    themeType: getStoredItem(STORAGE_KEY_THEME_TYPE) || 'light',
    isInitialPageLoad: true,
  } as State;
}

export function reducer(state = buildInitialState(), action: ThemeActions) {
  if (action.type === ThemeActionTypes.SetTheme) {
    const { themeType } = action.payload;
    setStoredItem(STORAGE_KEY_THEME_TYPE, themeType);
    if (themeType === state.themeType) {
      return state;
    }
    return { ...state, themeType, isInitialPageLoad: false };
  }
  return state;
}
